import React from "react";
import CourseLabel from "../CourseLists/CourseLabel";
import {QUARTER_SIZE} from "../../constants/cssConstants";
import CourseCodeContainer from "../CourseCodeContainer";
import compareArrays from "../../utils/compareArrays";
import {Skeleton} from "@material-ui/lab";
import PlanPanel from "./PlanPanel";

class Quarter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            courses: props.courses,
            isLoading: props.loading
        }

        this.addCourse = this.addCourse.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.loading !== this.props.loading || !compareArrays(prevProps.courses, this.props.courses)) {
            this.setState({ isLoading: this.props.loading, courses: this.props.courses });
        }
    }

    addCourse(courseCode) {
        this.props.addCourseToPlan(courseCode);
    }

    render() {
        return (
            <CourseCodeContainer onCourseAppears={this.addCourse} isQuarter>
                <div style={{width: QUARTER_SIZE, height: QUARTER_SIZE, backgroundColor: '#FFE680', marginBottom: 5,
                    boxShadow: '0px 4px 8px 0px rgba(0,0,0,0.75)'}}>
                    {
                        this.state.isLoading
                            ? <div>
                                <div style={{paddingTop: 4}}><Skeleton variant={"rect"} width={125} height={20}/></div>
                                <div style={{paddingTop: 4}}><Skeleton variant={"rect"} width={125} height={20}/></div>
                                <div style={{paddingTop: 4}}><Skeleton variant={"rect"} width={125} height={20}/></div>
                                <div style={{paddingTop: 4}}><Skeleton variant={"rect"} width={125} height={20}/></div>
                                <div style={{paddingTop: 4}}><Skeleton variant={"rect"} width={125} height={20}/></div>
                                <div style={{paddingTop: 6}}><Skeleton variant={"rect"} width={125} height={20}/></div>
                            </div>
                            : <div style={{ height: 130, overflowY: "auto" }}>
                                {
                                    this.state.courses.map((course) => <div
                                        style={{display:'flex', width: '100%', justifyContent: 'space-between'}}>
                                            <CourseLabel
                                                courseCode={course}
                                                inPlanPanel
                                                onCourseDisappear={this.props.removeCourse}
                                                setIsDragging={this.props.setIsDragging}
                                            />
                                            <div style={{ fontSize: 15, marginRight: 4, marginTop: 2 }}>
                                                {this.props.getCourseUnit ? this.props.getCourseUnit(course) : 0}
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                    }
                    {
                        !this.state.isLoading &&
                            <div style={{display:'flex', width: '100%', justifyContent: 'space-between', fontSize: 15}}>
                                <div style={{width: 105, textAlign: 'center'}}>Total Unit</div>
                                <div style={{marginRight: 3}}>
                                    {this.props.getQuarterTotalUnit ? this.props.getQuarterTotalUnit() : 0}
                                </div>
                            </div>
                    }
                </div>
            </CourseCodeContainer>
        );
    }
}

export default Quarter;